import axios from "axios";

const API_PATH = '/manage/users';

const FetchSource = async searches => (
	await axios.get(API_PATH, { params: searches })
);

const UserChangeStatus = async uId => (
	await axios.put(`${API_PATH}/${uId}/status`)
);

const UserResend = async uId => (
	await axios.put(`${API_PATH}/${uId}/resend`)
);

const CreateUser = async source => (
	await axios.post(API_PATH, source)
);

export { FetchSource, UserChangeStatus, UserResend, CreateUser } ;
